/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

/*
 *  Store redirect_uri/authorization_code in local storage to be used to later
 */

import { Auth } from "aws-amplify";

import { QUERY_PARAMS_KEYS, STORAGE_KEYS } from "../const";

async function handleIdpLogin(identity_provider) {
	const queryStringParams = new URLSearchParams(window.location.search);
	const redirect_uri = queryStringParams.get(QUERY_PARAMS_KEYS.redirectURI);
	const authorization_code = queryStringParams.get(
		QUERY_PARAMS_KEYS.authCode
	);
	const clientState = queryStringParams.get(QUERY_PARAMS_KEYS.state);
	const origin_uri = queryStringParams.get(QUERY_PARAMS_KEYS.originURI);

	if (redirect_uri) {
		localStorage.setItem(STORAGE_KEYS.redirectURI, redirect_uri);
	}
	if (authorization_code) {
		localStorage.setItem(STORAGE_KEYS.authCode, authorization_code);
	}
	if (clientState) {
		localStorage.setItem(STORAGE_KEYS.state, clientState);
	}

	if (origin_uri) {
		localStorage.setItem(STORAGE_KEYS.originURI, origin_uri);
	}

	await Auth.federatedSignIn({ provider: identity_provider });
}

export default handleIdpLogin;
